import React from 'react';
import { Button } from 'shards-react';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

type SearchButtonProps = {
  isLoading: boolean;
  onClick: (event: React.FormEvent | React.MouseEvent) => void;
};

const SearchButton = ({ isLoading, onClick }: SearchButtonProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <Button block theme="primary" type="submit" disabled={isLoading} onClick={onClick}>
      {!isLoading ? (
        t('filter.search')
      ) : (
        <>
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-1" />
          {t('filter.searching')}
        </>
      )}
    </Button>
  );
};

export default SearchButton;
